import { canv } from '@/canv/global.js'
import { randomIntFromInterval } from '@/canv/utils.js';

let DRAW_ERROR_LOGGED = false;

export class emoteVis {

    constructor(startX, startY, url) {

        this.baseX = startX;
        this.baseY = startY;
        this.startX = startX;
        this.startY = startY;
        this.opacity = 1;


        var sizeMin = 25;
        var sizeMax = 50;
        this.size = randomIntFromInterval(sizeMin / canv.m[0] * canv.dpr, sizeMax / canv.m[0] * canv.dpr);

        var velocityYMin = 6;
        var velocityYMax = 9;
        this.velocityY = randomIntFromInterval(velocityYMin / canv.m[0] * canv.dpr, velocityYMax / canv.m[0] * canv.dpr);

        var randomer = randomIntFromInterval(-1, 1);
        this.velocityX = randomer < 0 ? -5 / canv.m[0] * canv.dpr : 5 / canv.m[0] * canv.dpr;

        var radiusMin = 30;
        var radiusMax = 60;
        this.radius = randomIntFromInterval(radiusMin / canv.m[0] * canv.dpr, radiusMax / canv.m[0] * canv.dpr);

        var lengthMin = 250;
        var lengthMax = 400;
        this.length = randomIntFromInterval(lengthMin / canv.m[0] * canv.dpr, lengthMax / canv.m[0] * canv.dpr);


        var img = new Image();
        img.src = url;
        img.onload = this.imageOnLoad.bind(this, img);
    }

    imageOnLoad(img) {
        this.image = img;
    }

    draw() {
        if (!this.image) return; // image isn't to loaded

        try {
            canv.ctx.globalAlpha = this.opacity;
            canv.ctx.drawImage(this.image, this.startX, this.startY, this.size, this.size);
        } catch (e) {
            console.error(e);
            if (!DRAW_ERROR_LOGGED) {
                DRAW_ERROR_LOGGED = true;
                canv.captureException(e);
            }
        }
        canv.ctx.globalAlpha = 1;
    }

    step() {
        var lengthKoef = (this.length - Math.abs(this.baseY - this.startY)) / (this.length);
        this.startY -= this.easeOutBack(lengthKoef) * this.velocityY;
        this.opacity = this.easeOutBack(lengthKoef);

        var koef = (this.radius - Math.abs(this.startX - this.baseX)) / (this.radius);
        this.startX += this.easeOutBack(lengthKoef) * this.easeOutCubic(koef) * this.velocityX; // easeOutCubic

        if (this.startX < this.baseX - this.radius + 5 && this.velocityX < 0 || this.startX > this.baseX + this.radius - 5 && this.velocityX > 0) {
            this.velocityX *= -1;
        }

        if (this.baseY - this.startY > this.length - 2) {
            this.finished = true;
        }
    }

    easeOutCubic(x) {
        return 1 - Math.pow(1 - x, 3);
    }

    easeInOutBack(x) {
        const c1 = 1.70158;
        const c2 = c1 * 1.525;

        return x < 0.5
          ? (Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2)) / 2
          : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
    }

    easeInOutExpo(x) {
        return x === 0
          ? 0
          : x === 1
          ? 1
          : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2
          : (2 - Math.pow(2, -20 * x + 10)) / 2;
    }

    easeOutBack(x) {
        const c1 = 1.70158;
        const c3 = c1 + 1;

        return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
    }

    easeInOutCubic(x) {
        return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
    }

    easeInOutQuad(x) {
        return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    }

    easeOutQuad(x) {
        return 1 - (1 - x) * (1 - x);
    }

    easeOutQuint(x) {
        return 1 - Math.pow(1 - x, 5);
    }

    easeOutExpo(x) {
        return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
    }

    name = "emote";
    finished = false;
    startX = 0;
    startY = 0;
    size = 0;
    velocity = 0;
    opacity = 1;
}
